import { render, staticRenderFns } from "./antelayouts.vue?vue&type=template&id=1346866b&scoped=true&"
import script from "./antelayouts.vue?vue&type=script&lang=js&"
export * from "./antelayouts.vue?vue&type=script&lang=js&"
import style0 from "./antelayouts.vue?vue&type=style&index=0&id=1346866b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1346866b",
  null
  
)

export default component.exports